import React, { useEffect, useMemo, useState } from 'react'
import OtpInputs from '../components/OtpInputs'
import { useLocation, useNavigate } from 'react-router-dom'
import { LOGIN_CONSENT_TEXT, LoginConsentCopy } from './loginConsent'
import { useDispatch, useSelector } from 'react-redux'
import { closeErrorModal, openErrorModal, setError, setIsChecked, setOtp, setPopError } from '../lib/features/OtpSlice'
import { usePostOtpMutation } from '../lib/services/authApi'
import { generateChecksum } from '../lib/middleware/generateChecksum'
import PageHeader from '../components/PageHeader'
import CenteredPopup from '../components/popups/CenteredPopup'
import { ReactComponent as WarningIcon } from '../images/warning-icon.svg'
import { ReactComponent as EditIcon } from '../images/edit-icon-red.svg'
import { useTapClickMutation } from '../lib/middleware/TapClickApi';
import { pushCleverTapEvent, clevertapIdentitySet } from "../lib/middleware/CtEvents";


function Login() {
    const [tapClick] = useTapClickMutation()
    const otp = useSelector((state) => state.otp.otp);
    const pageerror = useSelector((state) => state.otp.error);
    const poperror = useSelector((state) => state.otp.poperror);
    const isChecked = useSelector((state) => state.otp.isChecked);
    const isErrorModalOpen = useSelector((state) => state.otp.isErrorModalOpen)
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
    const navigate = useNavigate()
    //const isChecked = useSelector((state) => state.otp.isChecked);
    const [postOtp, { isLoading }] = usePostOtpMutation()
    const dispatch = useDispatch();
    const location = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    //const phone = useMemo(() => queryParams.get('phone'), [queryParams])
    const secret = useMemo(() => queryParams.get('secret'), [queryParams])
    const utm_source = useMemo(() => queryParams.get("utm_source"), [queryParams]);
    const phone = localStorage.getItem('phone')
    const handleClose = () => {
        dispatch(closeErrorModal(false));
    }
    const errorModalButtons = [
        { label: 'Close', onClick: handleClose }
    ]
    /*useEffect(() => {
        if (!queryParams.has('phone')) {
            const defaultPhone = localStorage.getItem('phone');
            queryParams.set('phone', defaultPhone);
            navigate(`${location.pathname}?${queryParams.toString()}`, { replace: true });
        } else {
            localStorage.setItem('phone', phone)
        }
        //localStorage.setItem("lastVisitedPage", location.pathname)
    }, [phone, location, navigate, queryParams])*/
    useEffect(() => {
        if (secret) {
            localStorage.setItem('secret', secret)
        }
    }, [secret])
    useEffect(() => {
        const chkd = localStorage.getItem('isChecked')
        if (chkd) {
            dispatch(setIsChecked(Boolean(chkd)))
        }
    }, [dispatch])
    const handleOtpUpdate = (otp) => {
        dispatch(setOtp(otp))
    }
    const submitOtp = async () => {
        if (otp && otp.length === 4) {
            try {
                const consents = [
                    { consent_type: 'TERMS_OF_USE', consent_status: 'ACCEPTED', consent_text: LOGIN_CONSENT_TEXT },
                    { consent_type: 'PRIVACY_POLICY', consent_status: 'ACCEPTED', consent_text: LOGIN_CONSENT_TEXT },
                    { consent_type: 'CREDIT_SCORE_TERMS', consent_status: 'ACCEPTED', consent_text: LOGIN_CONSENT_TEXT },
                    { consent_type: 'WHATSAPP_CONSENT', consent_status: 'ACCEPTED', consent_text: LOGIN_CONSENT_TEXT },
                ]
                const requestData = {
                    phone_email: phone ? parseInt(phone.split(' ').join('')) : '',
                    otp: parseInt(otp),
                    mode: 'login',
                    phone: phone ? parseInt(phone.split(' ').join('')) : '',
                    device_id: localStorage.getItem('code'),
                    accept_status: isChecked,
                    utm_source: localStorage.getItem('utm_source'),
                    partner_unique_id: localStorage.getItem('partner_unique_id') || localStorage.getItem('partner_uniqueID') || null,
                    consents: JSON.stringify(consents),
                }
                const checksum = generateChecksum(requestData)
                const scrt = secret ? secret : localStorage.getItem('secret')
                const result = await postOtp({ ...requestData, checksum, secret: scrt })
                if (result.data && result.data.status === 'error') {
                    dispatch(setError(result.data.message))
                } else if (result.data && result.data.http_code === '201') {
                    dispatch(openErrorModal())
                    dispatch(setPopError(result.data.message))
                } else if (result.error) {
                    dispatch(openErrorModal())
                    dispatch(setPopError('Please check your internet or try again later.'))
                } else {
                    await clevertapIdentitySet({identity: result.data.customer_id})
                    localStorage.setItem('jwt', result.data.jwt_token)
                    //localStorage.setItem("lastVisitedPage", '/register')
                    //navigate(`/register`);
                    /*if(result.data.redirect_url){
                        navigate(`/register`)
                    } else{
                        window.location.href = 'https://devapi.stashfin.com/v2/api/web_landing_page?pan_card='
                    }*/
                    const event_name = localStorage.getItem('loginpage_event_name')
                    const phoneno = localStorage.getItem('phone')
                    const event_property = { Source: window.localStorage.getItem('utm_source'), Phone: `+91${phoneno.split(' ').join('')}` }
                    pushCleverTapEvent({ event_name, event_property })
                    dispatch(setOtp(null))
                    if (result.data.redirect_url) {
                        /*const checked = localStorage.getItem('isChecked')
                        if(checked){
                            localStorage.removeItem('isChecked')
                            //if(chkRef && chkRef.current) chkRef.current.style.display = 'none'
                        }*/
                        window.location.href = result.data.redirect_url
                    }
                }
            } catch (error) {
                dispatch(setError('Something went wrong. Please try again later.'));
            }
        } else {
            dispatch(setError('Please enter complete OTP.'));
        }
    }
    const checkIsKeyboardOpen = (value) => {
        setIsKeyboardOpen(value)
    }
    return (
        <div className={`external-wrapper otp-page ${isKeyboardOpen ? 'keyboard-active' : ''}`}>
            <CenteredPopup
                isOpen={isErrorModalOpen}
                buttons={errorModalButtons}
                onClose={handleClose} icon={<WarningIcon />}>
                <p>{poperror}</p>
            </CenteredPopup>
            <div className='page-content'>
                <PageHeader back={false} />
                <div className='page-heading'>
                    <h2 className='page-title'>Enter the OTP sent to your mobile number <br />{phone ? phone.split(' ').join('') : ''}</h2>
                    <EditIcon onClick={() => navigate('/')} className='edit-branding' style={{ cursor: 'pointer' }} />
                </div>
                <OtpInputs length={4} onOtpUpdate={handleOtpUpdate} error={pageerror} handleIsKeyboardOpen={checkIsKeyboardOpen} />
                {!localStorage.getItem('isChecked') ? <div className='consent-check'><label><div className={`checkbox ${isChecked ? 'checked' : ''}`}><input type="checkbox" checked={isChecked} onChange={() => dispatch(setIsChecked(!isChecked))} /></div> <LoginConsentCopy /></label></div> : null}
            </div>
            <div className='bottom-footer'>
                <p className='red-text'>Akara Capital Advisors Private Limited</p>
                <p className='tm-text'>Trademark of EQX Analytics Private Limited</p>
                {/*<button className={`btn btn-primary ${!isChecked || isLoading ? 'disabled' : ''}`} onClick={submitOtp}>Confirm</button>*/}
                <button className={`btn btn-primary ${!isChecked || isLoading ? 'disabled' : ''}`} onClick={submitOtp}>Confirm</button>
            </div>
        </div>
    )
}

export default Login